import headerImgEn from "assets/images/v123/header-en.webp"
import infoImgEn from "assets/images/v123/info-en.webp"

export const v123ConfigImages: Record<string, Record<string, string>> = {
  header: {
    en: headerImgEn,
  },
  info: {
    en: infoImgEn,
  },
}
